import Vue from 'vue';
import PackingListTable from './PackingListTable.vue';

$(document).ready(function() {
  const container = $('#packing-list-container');
  if (container.length) {
    new Vue({
      el: '#packing-list-container',
      template: '<PackingListTable />',
      components: {PackingListTable},
      data: container.data(),
    });
  }
});
